'use strict';

import React         from 'react';
import {Link}        from 'react-router';
import DocumentTitle from 'react-document-title';
import MyProfileStore from '../../stores/MyProfileStore';
import * as Connections from "../../utils/Connections.js";
import * as Cookies from "../../utils/Cookies";
export default class UpdateSettings extends React.Component {

    constructor(props) {
        super(props);
        this.state = {
            profile: {},
            name: '',
            location: '',
            email: '',
            phone: '',
            oldpassword: '',
            newpassword: '',
            repeatpassword: '',
            passwordMatch:false

        }
        this.updateUserDetails=this.updateUserDetails.bind(this);
        this.handleInputChange = this.handleInputChange.bind(this);
        this.onSave=this.onSave.bind(this);
        this.onSavePassword=this.onSavePassword.bind(this);

    }

    handleInputChange(e) {
        const name = e.target.name;

        this.setState({
            [name]: e.target.value
        });

    }

    onSave(e) {
        e.preventDefault();

        var data={
            "type":"updateMyProfile",
            "token":Cookies.checkCookie('accessToken'),
            "location":this.state.location,
            "email":this.state.email,
            "phone":this.state.phone,
            "password": "",
            "name":this.state.name,
        }
        Connections.updateProfile(data);


    }
    onSavePassword(e){
        e.preventDefault();
        this.validate();
    }
    validate() {
        this.setState({
            passwordMatch: (this.state.newpassword == this.state.repeatpassword) ? true : false
        }, function() {
            if (this.state.passwordMatch){
                //comunicate with the server updating password
                var data={
                    "type":"updateMyProfile",
                    "token":Cookies.checkCookie('accessToken'),
                    "location":this.state.location,
                    "email":this.state.email,
                    "phone":this.state.phone,
                    "password":this.state.newpassword,
                    "name":this.state.name,
                }
                Connections.updateProfile(data);
                // console.log(data);
            }else{
                alert('Please enter the same password');
            }
        });
    }
    updateUserDetails(){
        this.setState({
            profile:MyProfileStore.getProfileData(),
        });
        this.setState({
            name:this.state.profile.name,
            location:this.state.profile.location,
            email:this.state.profile.email,
            phone:this.state.profile.phone,
            newpassword:'',
            oldpassword:'',
            repeatpassword:''
        })
    }
    componentWillMount() {
        this.setState({
            profile:MyProfileStore.getProfileData()
        });
        MyProfileStore.on("change",this.updateUserDetails);
        Connections.getMyProfileEdit();
    }
    render() {
        return (
            <DocumentTitle title="Khula - User Settings">
                <div className="content">
                    <div style={
                        {
                            minHeight: '80vh',
                            marginTop: '25px',
                            marginBottom: '25px'
                        }
                    } className="container-fluid">
                    <div className="header">
                        <h2 className="lead">Update Profile</h2>
                    </div>
                    <form className="form-auth-small" onSubmit={this.onSave.bind(this)} >
                        <div className="form-group">
                            <label className="control-label">Name</label>
                            <input
                                type="text"
                                className="form-control"
                                name="name"
                                placeholder="Name"
                                value={this.state.name}
                                onChange={this.handleInputChange}
                            />
                        </div>

                        <div className="form-group">
                            <label className="control-label">Email</label>
                            <input
                                type="email"
                                className="form-control"
                                name="email"
                                placeholder="Email"
                                value={this.state.email}
                                onChange={this.handleInputChange}
                            />
                        </div>

                        <div className="form-group">
                            <label className="control-label">Contact Number</label>
                            <input
                                type="tel"
                                className="form-control"
                                name="phone"
                                placeholder="Contact Number"
                                value={this.state.phone}
                                onChange={this.handleInputChange}
                            />
                        </div>
                        <div className="form-group">
                            <label className="control-label">Physical Address</label>
                            <input
                                type="tel"
                                className="form-control"
                                name="location"
                                placeholder="Address"
                                value={this.state.location}
                                onChange={this.handleInputChange}
                            />
                        </div>

                        <button type="submit" className="btn btn-primary btn-lg btn-block" >UPDATE PROFILE</button>
                    </form>
                    <div className="header">
                        <p className="lead">Change password</p>
                    </div>
                    <form className="form-auth-small" onSubmit={this.onSavePassword.bind(this)} >
                        <div className="form-group">
                            <label className="control-label">Old Password</label>
                            <input
                                type="password"
                                className="form-control"
                                name="oldpassword"
                                placeholder="Old Password"
                                value={this.state.oldpassword}
                                onChange={this.handleInputChange}
                            />
                        </div>

                        <div className="form-group">
                            <label className="control-label">New Password</label>
                            <input
                                type="password"
                                className="form-control"
                                name="newpassword"
                                placeholder="New Password"
                                value={this.state.newpassword}
                                onChange={this.handleInputChange}
                            />
                        </div>

                        <div className="form-group">
                            <label className="control-label">Repeat New Password</label>
                            <input
                                type="password"
                                className="form-control"
                                name="repeatpassword"
                                placeholder="Repeat New Password"
                                value={this.state.repeatpassword}
                                onChange={this.handleInputChange}
                            />
                        </div>

                        <button type="submit" className="btn btn-primary btn-lg btn-block" >CHANGE PASSWORD</button>
                    </form>
                    </div>
                </div>
            </DocumentTitle>
        );
    }

}



// WEBPACK FOOTER //
// ./src/pages/HopePageBabies/UpdateSettings.js